import React, { useRef, useState } from 'react';
import Select from 'react-select';
import './index.scss';
import Tooltip from '../Tooltip';
import { useTranslation } from '../../hooks/useTranslation';

export default function CustomSelect({
  value = '',
  options,
  label,
  name = '',
  onChange,
  isMulti = false,
  defaultValue,
  tooltip = false,
  tooltipText,
  maxwidth,
  full,
  tooltipWidth = 0,
  id,
  disabled = false,
  scrollBottomOnChange = false,
  placeholder,
  isLoading = false,
}) {
  const selectRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const timeoutRef = useRef(null);
  const {t} = useTranslation();

  const handleMouseLeave = () => {
    // Add a longer delay to allow moving to the dropdown menu
    timeoutRef.current = setTimeout(() => {
      if (selectRef.current && isMenuOpen) {
        // Check if mouse is over any react-select menu
        const menuElements = document.querySelectorAll('[class*="menu"], [class*="Menu"]');
        let isOverMenu = false;
        
        menuElements.forEach(element => {
          if (element.matches(':hover')) {
            isOverMenu = true;
          }
        });
        
        if (!isOverMenu) {
          selectRef.current.blur();
        }
      }
    }, 10);
  };

  const handleMouseEnter = () => {
    // Clear the timeout if mouse re-enters
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const onOpenSelector = () => {
    const modalContent = document.getElementsByClassName('modal__content-body');
    if (modalContent.length > 0 && scrollBottomOnChange) {
      const element = modalContent[0];

      setTimeout(() => {
        element.scrollTop = element.scrollHeight + 50;
      }, 5);
    }
  };
  const onDataChange = (value, action) => {
    if (name === 'inspection_revisions') {
      onChange(value);
    } else {
      onChange({
        target: {
          name: action.name,
          value: value.value,
          id: action.name,
        },
      });
    }
  };

  const selectedOption =
    value != null && value !== '' && options?.length
      ? options.find((opt) => opt.value === value || opt.value === String(value))
      : null;
  const isControlled = value !== undefined && value !== '';

  return (
    <div
      className={`customSelect ${full ? 'full' : ''}`}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
    >
      <span className='customSelect__label'>
        {label}
        {tooltip && (
          <Tooltip tooltipText={tooltipText} tooltipWidth={tooltipWidth} />
        )}
      </span>
      <Select
        ref={selectRef}
        options={options}
        value={isControlled ? selectedOption : undefined}
        defaultValue={!isControlled && defaultValue ? defaultValue : undefined}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
            borderRadius: 8,
            height: 42,
            backgroundColor: '#F4F5F6',
            marginTop: 8,
            width: maxwidth,
          }),
          menuPortal: (baseStyles) => ({
            ...baseStyles,
            zIndex: 9999,
            marginTop: -7,
          }),
        }}
        menuPortalTarget={document.body}
        id={id}
        isMulti={isMulti}
        isLoading={isLoading}
        loadingMessage={() => 'Loading...'}
        name={name}
        onChange={onDataChange}
        isDisabled={disabled}
        onMenuOpen={() => {
          setIsMenuOpen(true);
          onOpenSelector();
        }}
        placeholder={placeholder ? placeholder : t('customSelect.select')}
        onMenuClose={() => setIsMenuOpen(false)}
      />
    </div>
  );
}
